import { doPost, doPost2 } from './common'

export const start = (breakId, stepId) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
  }

  return doPost(`/review/start/`, payload)
}

export const complete = (breakId, stepId, nonce, stepSkipped) => {
  let payload = {
    breakId: breakId,
    stepId: stepId,
    nonce: nonce,
    skipped: stepSkipped,
  }

  return doPost(`/review/complete/`, payload)
}

export const reminder = (breakId, reviewId, productId, email) => {
  let payload = {
    breakId: breakId,
    reviewId: reviewId,
    productId: productId,
    email: email,
  }

  return doPost2(`/review/schedule/`, payload)

  // return new Promise((resolve) => setTimeout(resolve, 1000))
}

export const submit = (
  breakId,
  reviewId,
  productId,
  rating,
  headline,
  comments,
  nickname,
  email,
  ioBlackBox,
  reviewSessionId,
) => {
  let payload = {
    breakId,
    reviewId,
    productId,
    rating,
    title: headline,
    detail: comments,
    nickname,
    email,
    fingerprint: ioBlackBox,
    reviewSessionId,
  }

  return doPost2(`/review/submit/`, payload)
  // console.log(payload)
  // return new Promise((resolve) => setTimeout(resolve({status: 200}), 1000))
}
